/* eslint-disable prefer-destructuring */
/* eslint-disable max-len */

export const getSelectedAppointment = (state) => state.account?.selectedAppointment || '';
export const getNextAppointmentDate = (state) => state.account?.nextAppointmentDate || '';
export const getFavoriteStore = (state) => state.account?.favoriteStore || {};
export const getOktaUserInfo = (state) => state?.account?.authUserDetails || {};

export default {};
